import { SceneViewer } from '../components/react/SceneViewer';
import { useLocation } from 'react-router-dom';

const useQuery = (search: string) => {
  return new URLSearchParams(search);
};

export const SceneViewerRoute: React.FC = () => {
  const { search } = useLocation();
  const query = useQuery(search);

  return <SceneViewer sceneID={query.get('p') ?? ''} />;
};
